import * as React from "react";
import Loader from 'react-loader';
import { Redirect } from "react-router-dom";
import SortableTbl from "react-sort-search-table";
import { toast, ToastContainer} from 'react-toastify';
import {Button,Col, Input, Row} from 'reactstrap';

import SortableTable from "../../../../components/Admin/PaginationTable/PaginationTable.Component";
import Navbar from '../../../../components/CustomNav/CustomNav.Component';
import withServices  from '../../../../HOCs/withServices';
import { Wrapper, Content , ContentRow} from './UserProfilesList.styles'

interface IProps {
    services?: any;
    location?: any;
    match?: any;
    history?: any;
}
  
interface IState {
    toLogin: boolean;
    loaded: boolean;
    data: any;
    selectedLesson: string;
    isNavigate: boolean;
    destination: string;
}

class ListUserProfiles extends React.Component<IProps, IState> {
    constructor(props) {
        super(props);
    
        this.state = {
          destination: '',
          toLogin: false,
          loaded: true,
          isNavigate: false,
          data: {},
          selectedLesson: '',
        };
    
        this.onLogout = this.onLogout.bind(this);
        this.onGoBack = this.onGoBack.bind(this);
        // this.goToProfileEdit = this.goToProfileEdit.bind(this);
        this.fetchProfiles = this.fetchProfiles.bind(this);
        this.viewMoreData = this.viewMoreData.bind(this);
    }

    public customTD = (props) => {
        return (
          <td>
            {/*tslint:disable-next-line jsx-no-lambda*/}

            <button
              className="green-button"
              style={{ margin: "0 .75em .5em 0", padding: ".375em", fontSize: "16px" }}
              onClick={this.triggerCleanup.bind(this, props)}
            >
              AR Fix

            </button>


            {/*tslint:disable-next-line jsx-no-lambda*/}

            <button
              className="white-button"
              style={{ margin: "0 .75em .5em 0", padding: ".375em", fontSize: "16px" }}
              onClick={this.triggerARRun.bind(this, props)}
            >
              AR Run

            </button>


            {/*tslint:disable-next-line jsx-no-lambda*/}
            <button
              className="blue-button"
              style={{ margin: "0 .75em .5em 0", padding: ".375em", fontSize: "16px" }}
              onClick={this.viewMoreData.bind(this, props)}
            >
               Edit Profile 
            </button>
          </td>
        );
      };

      public viewMoreData(props) {
        const history: any = this.props.history;
        history.push(`/admins/userprofiles/${props.rowData.UserProfileId}`);
      }

      public triggerCleanup(props) {
        const result = window.confirm("Are you sure you want to send a cleanup request?");

        if (result) {
            this.sendCleanupRequest(props.rowData.id);
        }
      }

      public triggerARRun(props) {
        const result = window.confirm("Are you sure you want to send an Autorecommender run request?");

        if (result) {
            this.sendARRunRequest(props.rowData.id);
        }
      }


    public onGoBack() {
        const dest = this.props.services.currentBaseUrl + 'home/';
        
        this.setState({
            isNavigate: true,
            destination: dest
        })
    }

    
    public onLogout() {
        this.setState({ toLogin: true });
    }



    public async sendCleanupRequest(id) {
        const {
          services: { adminAPI },
        } = this.props;

        const item = {
            User_id: id,
            operation: "learner_cleanup",
        };

        const res = await adminAPI.requestLearnerWorspaceOperation(item);

        if (res.ok) {
          if(res.data.found_allocations) {
            toast.success("Operation successful! Allocation found. Nothing to do.");

          }
          else {
            toast.success("Request sent, please click on AR run to complete.");
          }
        } else {
            toast.error("Error sending request!");
        }

        return res;
      }


      public async sendARRunRequest(id) {
        const {
          services: { adminAPI },
        } = this.props;

        const item = {
            User_id: id,
            operation: "learner_autorecommend_workspace",
        };

        const res = await adminAPI.requestLearnerWorspaceOperation(item);

        if (res.ok) {
          toast.success("Request sent successfully!");
        } else {
            toast.error("Error sending request!");
        }

        return res;
      }
   

    public async fetchProfiles(page, size, searchString) {
        const {
          services: { adminAPI },
        } = this.props;


      // show loader

      this.setState({
        ...this.state,
        data: {
          ...this.state.data,
          loaded: false,
        },
      });

       const membersRes = await adminAPI.getAllProfiles(page, size, searchString);
   
       if (membersRes.ok) {
         const profiles = membersRes.data.profiles;
   
         this.setState({
           ...this.state,
           data: {
             ...this.state.data,
             profiles,
             pageCount: membersRes.data.page_count,
              loaded: true,
           },
         });
       } else {
         toast.error("Error fetching interaction details!");
       }
     }

    public async componentDidMount() {
        const {
            match,
            history,
            location,
            services: { isUserLoggedIn, adminAPI, currentUserID },
        } = this.props;

 
        if (!isUserLoggedIn) { this.setState({ toLogin: true }); }

        const profilesDataKey = ["id", "User", "PreAssesmentDone", "UpgradedPreAssesmentDone", "ParentStudentCode"];
        
        const profilesThead = ["ID", "Name", "0.5 Done", "1.0 Done", "Action"];

        const profilesRes = await adminAPI.getAllProfiles(1, 10);

        if (profilesRes.ok) {
            
            const profiles = profilesRes.data.profiles;

            this.setState(
                {
                     data: {
                        profiles,
                        loaded: true,
                        profilesDataKey,
                        profilesThead,
                        pageCount: profilesRes.data.page_count
                     }
                }
            )
        } else {
            toast.error('Error fetching interaction details!');
        }
    }

    public showProgressIcon(state) {
      if (!state.loaded) {
        return <i className="fa fa-spinner fa-spin"  style={
          { fontSize: "2em", color: "#acff24", marginTop: "1em" }
        }/>;
      }
      return '';
    }


    public render() {
        const {data} = this.state;
    
        if (this.state.toLogin) {
          return <Redirect to="/login" />;
        }

        if (this.state.isNavigate) {
            return <Redirect to={this.state.destination} />;
          }
    
        if (Object.keys(data).length === 0) {
          return <Loader color="#acff24" />;
        }

        return (
            <Wrapper>
              <ToastContainer/>
              <Navbar logoutParent={this.onLogout} />
              <Content>
                <ContentRow className="single-col">
                  <p className="go-back" onClick={this.onGoBack}>&lt; Back</p>
                </ContentRow>
              </Content>



              <Content>

              <Content>
                {this.showProgressIcon(data)}
              </Content>


              <SortableTable
            {...this.props}
            tableData={data.profiles}
            tableHead={data.profilesThead}
            dataKeys={data.profilesDataKey}
            apiCall={this.fetchProfiles}
            pageCount={data.pageCount}
            customTd={[
              {
                custd: this.customTD,
                keyItem: "ParentStudentCode",
                sortable: false,
              }
            ]}
            searchKey="profiles"
          />
          

              </Content>

             
              </Wrapper>
        );

    }

}

export default withServices(ListUserProfiles);


// WEBPACK FOOTER //
// ./src/pages/Admin/UserProfiles/ListUserProfiles/UserProfilesList.tsx